// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i4-j";
export var fulfillmentFormRail = "_i4-i";
export var headerTitleRow = "_i4-l";
export var orderDetailsWrapper = "_i4-g";
export var orderLinkTrigger = "_i4-2";
export var paymentInformationGrid = "_i4-q";
export var paymentSummaryColumn = "_i4-r";
export var phoneShipmentPickerButton = "_i4-e";
export var phoneShipmentPickerButtonContent = "_i4-f";
export var phoneShipmentPickerButtonWrapper = "_i4-d";
export var phoneShipmentPickerTrigger = "_i4-c";
export var shipmentContainer = "_i4-k";
export var shipmentDetailsMainPane = "_i4-h";
export var shipmentNavigationCard = "_i4-a";
export var shipmentNavigationEdgeTrigger = "_i4-6";
export var shipmentNavigationRail = "_i4-3";
export var shipmentNavigationRailEnter = "_i4-5";
export var shipmentNavigationRailHeader = "_i4-9";
export var shipmentNavigationRailOverlay = "_i4-4";
export var shipmentNavigationScrim = "_i4-7";
export var shipmentSummaryFact = "_i4-n";
export var shipmentSummaryGrid = "_i4-m";
export var shipmentSummaryMetadataRow = "_i4-o";
export var shipmentSummaryTags = "_i4-p";
export var shipmentWorkspace = "_i4-0";
export var shipmentWorkspaceBodyTablet = "_i4-8";
export var shipmentWorkspaceContent = "_i4-b";
export var shipmentWorkspaceHeader = "_i4-1";